export const PFE_HISTORY_KEY = 'pfeHistory';
export const PFE_VISITED_KEY = 'pfeVisitedPages';

/**
 * This key in the state is reserved for all internal pfe data.
 * In general, it is desirable to also migrate existing previous keys over to this.
 * For example pfeHistory, etc...
 * But as those are used in a lot of places, that is a bigger, breaking, effort
 */
export const PFE_STATE_INTERNAL_STATE_KEY = '_pfe';

export const PFE_STATE_NAVIGATING_FROM = `$.${PFE_STATE_INTERNAL_STATE_KEY}.navigationState.navigatingFrom`;

export const PFE_STATE_NAVIGATING_TO = `$.${PFE_STATE_INTERNAL_STATE_KEY}.navigationState.navigatingTo`;
